module.exports = __webpack_public_path__ + "static/media/Yellow.1d6f0c95.wav";


//////////////////
// WEBPACK FOOTER
// ./src/Sounds/Yellow.wav
// module id = 52
// module chunks = 0